var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tile-content tile-content-secondary"},[_vm._v("Churn the subscription.")])}
var staticRenderFns = []

export { render, staticRenderFns }